import Controls from "../components/Controls";
import RoomPage from "../components/RoomPage";

export default function LegacyPage() {
  return <RoomPage roomId="legacy" slug="mariaffiek" className="legacy-page" heroClassName="legacy-room-hero" headingClassName="legacy-heading" navigation={<Controls backTo="/petkiek" nextTo="/mariaffiek/peter" />} />;
}
